import { render, staticRenderFns } from "./RelatorioFunerario.vue?vue&type=template&id=2750bf13&scoped=true"
import script from "./RelatorioFunerario.vue?vue&type=script&lang=js"
export * from "./RelatorioFunerario.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFunerario.vue?vue&type=style&index=0&id=2750bf13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2750bf13",
  null
  
)

export default component.exports